import React from "react";

const testimonials = [
  {
    initials: "LA",
    quote: "He has been an amazing team player. Strong with quick solutions, along with professional in implementing an optimised solution. He always guns up for the code & team. Definitely a Leader, in making...",
    name: "Lajeet Adhikary",
    role: "Tech Lead at YourStory",
  },
  {
    initials: "JS",
    quote: "He has been a pleasure to work with, bringing his attention to detail to every project. His communication and people skills are excellent, and he always has some very innovative ideas.",
    name: "Jitesh Shinde",
    role: "Special Project Manager, CrimzonCode Technologies",
  },
  {
    initials: "AO",
    quote: "Lakshay has consistently been a strong employee capable of taking control of the entire project and executing to the fullest. He's a pleasure to work with. Lakshay is my senior and I love working with him — got to learn a lot throughout the whole duration of internship and job.",
    name: "Akshit Ostwal",
    role: "Co-Founder, Orange Wallet",
  },
  {
    initials: "PS",
    quote: "Fantastic work! I am just impressed by his service quality and working strategy. He has great expertise, is dedicated, attentive, talented and cares much about the product needs. Highly recommended.",
    name: "Pranali Sawakhande",
    role: "Project Associate, CrimzonCode",
  },
];

const TestimonialAnimation = () => {
  return (
    <section className="d2-testimonials" id="testimonials" aria-labelledby="testimonials-title">
      <div className="d2-container">
        <span className="section-label reveal">Kind Words</span>
        <h2 className="section-title reveal reveal-delay-1" id="testimonials-title">Testimonials</h2>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <article className={`testimonial-card reveal${i > 0 ? ` reveal-delay-${i}` : ""}`} key={t.name}>
              <blockquote className="testimonial-quote">{t.quote}</blockquote>
              <div className="testimonial-author">
                <div className="testimonial-avatar" aria-hidden="true">{t.initials}</div>
                <div>
                  <div className="testimonial-name">{t.name}</div>
                  <div className="testimonial-role">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialAnimation;
